
import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import UsefulLinksTable from '../../containers/domain/useful-link/UsefulLinksTable';

const UsefulLinksListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de links úteis"
        content={<UsefulLinksTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default UsefulLinksListingView;
